import React from 'react';
import { makeStyles } from '@material-ui/core';
import { Modal, BoxWrapper, Button } from 'components/Base';

const useStyles = makeStyles({
  container: {
    display: 'flex',
    minWidth: '25rem',
    maxWidth: '100%',
    justifyContent: 'space-between',
    padding: '1rem'
  }
});

interface Props {
  isOpen: boolean;
  confirmAction: () => void;
  cancelAction: () => void;
  title: string;
  isProcessing: boolean;
}

const Prompt = ({
  isOpen,
  confirmAction,
  cancelAction,
  title,
  isProcessing
}: Props) => {
  const classes = useStyles();
  return (
    <Modal isOpen={isOpen} closeModalFunc={cancelAction}>
      <BoxWrapper title={title}>
        <div className={classes.container}>
          <Button onClick={cancelAction} color="primary" type="button">
            Cancel
          </Button>
          <Button
            onClick={confirmAction}
            isLoading={isProcessing}
            type="submit"
          >
            Confirm
          </Button>
        </div>
      </BoxWrapper>
    </Modal>
  );
};

export default Prompt;
